export const policyCancellationMethodReceived = [
  {
    value: 'in_store',
    label: 'POLICY_CANCELLATION.methodReceived.store',
  },
  {
    value: 'email',
    label: 'POLICY_CANCELLATION.methodReceived.email',
  },
  {
    value: 'phone',
    label: 'POLICY_CANCELLATION.methodReceived.phone',
  },
];
